import { Navigate, useOutlet } from "react-router-dom";

export const ProtectedLayout = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const outlet = useOutlet();

  if (!userData) {
    return <Navigate to="/" />;
  }

  return <div>{outlet}</div>;
};
